import { SET_SAVE_BOOK_FLAG } from '../../action-types/ui/isSavedBook';

export const STATE_KEY = 'isSavedBook';

export const isSavedBook = (state = false, action) => {
  switch (action.type) {
    case SET_SAVE_BOOK_FLAG: {
      const { flag } = action;
      return flag;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/isSavedBook.js